import { addDays, differenceInCalendarDays } from "date-fns"

// Its own module, not noosPoUtils, so server-side tests can import it without the React/Highcharts
// component graph buildNoosPoBatches depends on.

// What a newly created buy is meant to cover, i.e. the window its suggested quantities are scored
// against and the window persisted on its POs (`periodEnd = coverUntil + leadTime`).
//
// A regular buy is placed at the next buy date and covers one purchase interval — the supply plan's
// cadence. A buy created from Stockout Alerts (`isScoped`) is placed now precisely because stock
// runs out before the next planned buy arrives, so it must cover exactly until that next buy — the
// same window the overview's "Suggested order" column uses. Scoring it over the plan interval
// instead is what made the quantities jump when a suggestion became a buy (SLIM-576).
//
// `nextBuyDate` only names a *future planned* buy when it falls after the buy being created: the
// supply plan detail context falls back to the earliest open buy's date, which is today or earlier
// as soon as one order-now buy exists. Covering "until then" would be a zero-length window, so in
// that state the buy keeps the plan cadence instead of baking a one-day period onto its POs.
export function getBuyCoverageWindow({
  buyDate,
  nextBuyDate,
  purchaseInterval,
  isScoped,
}: {
  buyDate: Date
  nextBuyDate: Date
  purchaseInterval: number
  isScoped: boolean
}): { coverUntil: Date; coverageDays: number } {
  const daysUntilNextBuy = differenceInCalendarDays(nextBuyDate, buyDate)
  const coverUntil =
    isScoped && daysUntilNextBuy >= 1 ? nextBuyDate : addDays(buyDate, purchaseInterval)
  return { coverUntil, coverageDays: Math.max(1, differenceInCalendarDays(coverUntil, buyDate)) }
}
